import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export const Comparison = () => {
  return <section className="py-16 md:py-20 border-t border-slate-200" data-id="element-383">
      <div className="flex flex-col md:flex-row gap-8 mb-12" data-id="element-384">
        <div className="md:w-1/3" data-id="element-385">
          <img src="https://images.unsplash.com/photo-1579684385127-1ef15d508118?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=80" alt="Sleep patch application" className="w-full h-64 md:h-full object-cover rounded-xl shadow-md" data-id="element-386" />
        </div>
        <div className="md:w-2/3" data-id="element-387">
          <h2 className="text-2xl font-bold text-slate-800 mb-4 px-4 md:px-0" data-id="element-388">
            The NightPhase Advantage
          </h2>
          <p className="text-slate-600 mb-8 px-4 md:px-0" data-id="element-389">
            Why leading executives choose transdermal technology over
            traditional sleep solutions
          </p>
          <div className="bg-white rounded-xl shadow-md overflow-hidden mb-12" data-id="element-390">
            <div className="grid grid-cols-3" data-id="element-391">
              <div className="p-4 border-b border-slate-200" data-id="element-392">
                <p className="font-medium text-slate-800" data-id="element-393">Features</p>
              </div>
              <div className="p-4 border-b border-slate-200 bg-indigo-50" data-id="element-394">
                <p className="font-bold text-indigo-800" data-id="element-395">NightPhase Patches</p>
              </div>
              <div className="p-4 border-b border-slate-200" data-id="element-396">
                <p className="font-medium text-slate-800" data-id="element-397">
                  Traditional Sleep Pills
                </p>
              </div>
            </div>
            {/* Row 1 */}
            <div className="grid grid-cols-3" data-id="element-398">
              <div className="p-4 border-b border-slate-200 bg-slate-50" data-id="element-399">
                <p className="text-slate-700" data-id="element-400">
                  Consistent delivery throughout night
                </p>
              </div>
              <div className="p-4 border-b border-slate-200 bg-indigo-50 flex justify-center" data-id="element-401">
                <CheckIcon className="h-5 w-5 text-green-600" data-id="element-402" />
              </div>
              <div className="p-4 border-b border-slate-200 flex justify-center" data-id="element-403">
                <XIcon className="h-5 w-5 text-red-500" data-id="element-404" />
              </div>
            </div>
            {/* Row 2 */}
            <div className="grid grid-cols-3" data-id="element-405">
              <div className="p-4 border-b border-slate-200" data-id="element-406">
                <p className="text-slate-700" data-id="element-407">No morning grogginess</p>
              </div>
              <div className="p-4 border-b border-slate-200 bg-indigo-50 flex justify-center" data-id="element-408">
                <CheckIcon className="h-5 w-5 text-green-600" data-id="element-409" />
              </div>
              <div className="p-4 border-b border-slate-200 flex justify-center" data-id="element-410">
                <XIcon className="h-5 w-5 text-red-500" data-id="element-411" />
              </div>
            </div>
            {/* Row 3 */}
            <div className="grid grid-cols-3" data-id="element-412">
              <div className="p-4 border-b border-slate-200 bg-slate-50" data-id="element-413">
                <p className="text-slate-700" data-id="element-414">Zero dependency risk</p>
              </div>
              <div className="p-4 border-b border-slate-200 bg-indigo-50 flex justify-center" data-id="element-415">
                <CheckIcon className="h-5 w-5 text-green-600" data-id="element-416" />
              </div>
              <div className="p-4 border-b border-slate-200 flex justify-center" data-id="element-417">
                <XIcon className="h-5 w-5 text-red-500" data-id="element-418" />
              </div>
            </div>
            {/* Row 4 */}
            <div className="grid grid-cols-3" data-id="element-419">
              <div className="p-4 border-b border-slate-200" data-id="element-420">
                <p className="text-slate-700" data-id="element-421">
                  Preserves natural sleep architecture
                </p>
              </div>
              <div className="p-4 border-b border-slate-200 bg-indigo-50 flex justify-center" data-id="element-422">
                <CheckIcon className="h-5 w-5 text-green-600" data-id="element-423" />
              </div>
              <div className="p-4 border-b border-slate-200 flex justify-center" data-id="element-424">
                <XIcon className="h-5 w-5 text-red-500" data-id="element-425" />
              </div>
            </div>
            {/* Row 5 */}
            <div className="grid grid-cols-3" data-id="element-426">
              <div className="p-4 border-b border-slate-200 bg-slate-50" data-id="element-427">
                <p className="text-slate-700" data-id="element-428">
                  Optimized for cognitive performance
                </p>
              </div>
              <div className="p-4 border-b border-slate-200 bg-indigo-50 flex justify-center" data-id="element-429">
                <CheckIcon className="h-5 w-5 text-green-600" data-id="element-430" />
              </div>
              <div className="p-4 border-b border-slate-200 flex justify-center" data-id="element-431">
                <XIcon className="h-5 w-5 text-red-500" data-id="element-432" />
              </div>
            </div>
            {/* Row 6 */}
            <div className="grid grid-cols-3" data-id="element-433">
              <div className="p-4" data-id="element-434">
                <p className="text-slate-700" data-id="element-435">Measurable performance ROI</p>
              </div>
              <div className="p-4 bg-indigo-50 flex justify-center" data-id="element-436">
                <CheckIcon className="h-5 w-5 text-green-600" data-id="element-437" />
              </div>
              <div className="p-4 flex justify-center" data-id="element-438">
                <XIcon className="h-5 w-5 text-red-500" data-id="element-439" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-indigo-800 text-white rounded-xl p-6 md:p-8 mx-4 md:mx-0" data-id="element-440">
        <h3 className="text-xl font-bold mb-6" data-id="element-441">
          The Executive Performance ROI
        </h3>
        <div className="flex flex-col md:flex-row gap-8" data-id="element-442">
          <div className="md:w-1/4" data-id="element-443">
            <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=80" alt="Business growth chart" className="w-full h-48 md:h-full object-cover rounded-lg" data-id="element-444" />
          </div>
          <div className="md:w-3/4" data-id="element-445">
            <p className="mb-6" data-id="element-446">
              For high-performing professionals, sleep isn't just about
              rest—it's about competitive advantage. Our clients report an
              average 300% return on investment within 90 days through:
            </p>
            <ul className="space-y-4 mb-6" data-id="element-447">
              <li className="flex items-start" data-id="element-448">
                <CheckIcon className="h-5 w-5 text-green-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-449" />
                <span data-id="element-450">22-38% increase in productive work hours</span>
              </li>
              <li className="flex items-start" data-id="element-451">
                <CheckIcon className="h-5 w-5 text-green-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-452" />
                <span data-id="element-453">40% faster decision-making on complex problems</span>
              </li>
              <li className="flex items-start" data-id="element-454">
                <CheckIcon className="h-5 w-5 text-green-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-455" />
                <span data-id="element-456">Elimination of costly errors due to mental fatigue</span>
              </li>
              <li className="flex items-start" data-id="element-457">
                <CheckIcon className="h-5 w-5 text-green-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-458" />
                <span data-id="element-459">
                  Reduced healthcare costs associated with chronic sleep
                  deprivation
                </span>
              </li>
            </ul>
            <p className="font-medium" data-id="element-460">
              When calculated against your hourly value, NightPhase delivers
              measurable returns that compound over time.
            </p>
          </div>
        </div>
      </div>
    </section>;
};